module.exports = __webpack_public_path__ + "static/media/IconShieldCheck.4d83d9e0.svg";